<template>
  <div :class="[side % 2 ? 'left-side' : 'right-side']">
    <div class="history-column">
      <label>Saison</label>
      {{ history.season }}
    </div>
    <div class="history-column">
      <label>Verein</label>
      {{ history.team }}
    </div>
    <div class="history-column">
      <label>Altersklasse</label>
      {{ history.class }}
    </div>
    <div class="history-column">
      <label>Funktion</label>
      {{ history.trainer_function }}
    </div>
    <div v-if="history.league" class="history-column">
      <label>Liga</label>
      {{ history.league.league }}
    </div>
    <div v-if="showMore">
      <div class="history-column">
        <label>Spiele</label>
        {{ history.games_player }}
      </div>
      <div class="history-column">
        <label>Siege</label>
        {{ history.wins }}
      </div>
      <div class="history-column">
        <label>Unentschieden</label>
        {{ history.tie }}
      </div>
      <div class="history-column">
        <label>Niederlagen</label>
        {{ history.lost }}
      </div>
      <div class="history-column">
        <label>Tore</label>
        {{ history.goals }}
      </div>
      <div class="history-column">
        <label>Gegentore</label>
        {{ history.goal_against }}
      </div>
      <div @click="showMore = false" class="more">Weniger anzeigen</div>
    </div>
    <div @click="showMore = true" class="more" v-else>Mehr anzeigen</div>
  </div>
</template>

<script>
export default {
  props: ['history', 'side'],
  data: () => ({
    showMore: false,
  }),
};
</script>
